import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import TarotCardFlip, { cardOfTheDay } from "@/components/TarotCardFlip";

const STORAGE_KEY = "fy_tarot_day";

export default function DailyTarotModal() {
  const [open, setOpen] = useState(false);
  const [revealed, setRevealed] = useState(false);
  const [card] = useState(cardOfTheDay);

  useEffect(() => {
    const today = new Date().toDateString();
    if (localStorage.getItem(STORAGE_KEY) !== today) {
      const t = setTimeout(() => {
        setOpen(true);
        localStorage.setItem(STORAGE_KEY, today);
      }, 1100);
      return () => clearTimeout(t);
    }
  }, []);

  const close = () => setOpen(false);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[80] flex items-center justify-center px-5 py-10 overflow-y-auto"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
          data-testid="tarot-modal"
        >
          <div className="absolute inset-0 bg-[#0b0605]/85 backdrop-blur-md" onClick={close} />

          <motion.div
            initial={{ opacity: 0, scale: 0.94, y: 24 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.96, y: 12 }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            className="relative gold-frame rounded-sm bg-[#140B09] px-6 sm:px-10 py-10 max-w-lg w-full my-auto flex flex-col items-center text-center"
          >
            <button
              onClick={close}
              data-testid="tarot-modal-close"
              aria-label="Close"
              className="absolute top-4 right-4 text-[#B7A488] hover:text-[#E9D3A0] transition-colors"
            >
              <X className="w-5 h-5" strokeWidth={1.5} />
            </button>

            <span className="text-[11px] tracking-[0.4em] uppercase text-[#C9A24B] mb-3">✦ A gift before you begin ✦</span>
            <h2 className="font-display text-3xl sm:text-4xl tracking-tight text-[#EFE3CC] mb-8">
              Draw your card for <span className="italic text-gold-gradient">today</span>
            </h2>

            <TarotCardFlip
              card={card}
              revealed={revealed}
              onReveal={() => setRevealed(true)}
              onCta={close}
              testidPrefix="modal-tarot"
            />

            {!revealed && (
              <button onClick={close} data-testid="tarot-modal-skip" className="mt-8 text-[11px] tracking-[0.2em] uppercase text-[#7a6a55] hover:text-[#B7A488] transition-colors">
                Maybe later
              </button>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
